<mat-form-field fxFlex class="field-full-width">
    <mat-label>{{label}}</mat-label>
    <input matInput mat-autoresize="true" [value]="description" placeholder="Médecin" aria-label="State" [matAutocomplete]="auto" [formControl]="searchDoctorsCtrl">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
      <ng-container *ngIf="!isLoading">
        <mat-option *ngFor="let doctor of filteredDoctors" [value]="doctor.ID" style="height:150px;border-bottom: 1px gray solid;">
          <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field floatLabel="always" fxFlex class="field-full-width">
                <mat-label>Prénom</mat-label>
                <input matInput class="mat-input-element-undisabled" disabled="true" [value]="doctor.firstname" mat-autoresize="true">
            </mat-form-field>
            <mat-form-field floatLabel="always" fxFlex class="field-full-width">
                <mat-label>Nom</mat-label>
                <input matInput class="mat-input-element-undisabled" disabled="true" [value]="doctor.lastname" mat-autoresize="true">
            </mat-form-field>
          </div>
          <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field floatLabel="always" fxFlex class="field-full-width">
                <mat-label>Code postal</mat-label>
                <input matInput class="mat-input-element-undisabled" disabled="true" [value]="doctor.zip" mat-autoresize="true">
            </mat-form-field>
            <mat-form-field floatLabel="always" fxFlex class="field-full-width">
                <mat-label>Commune</mat-label>
                <input matInput class="mat-input-element-undisabled" disabled="true" [value]="doctor.city" mat-autoresize="true">
            </mat-form-field>
          </div>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
</mat-form-field>

